import React from 'react';

import s from './NavSecondary.scss';
import { Link } from 'components/link/Link';

interface INavSecondaryList {
  link: string;
  title: string;
}

interface IProps {
  children?: React.ReactNode;
  info: React.ReactNode;
  list: INavSecondaryList[];
}

export const NavSecondary = ({ children, info, list }: IProps) => {
  return (
    <div className={s.navSecondary}>
      {info ?? null}
      {list && list.length > 0 && (
        <ul className={s.navSecondary__list}>
          {list.map((item: INavSecondaryList, i: number) => (
            <li key={i} className={s.navSecondary__item}>
              <Link to={item.link}>{item.title}</Link>
            </li>
          ))}
        </ul>
      )}

      {children}
    </div>
  );
};
